import React from "react";
import Router from "app/router";
import { useLiveSession } from "app/hooks/useLiveSession";
import { CookieSnackbar } from "app/components/cookie-snackbar";
import LoginFlowBackdrop from "app/components/login-flow-backdrop";

export const DEFAULT_YEAR_FILTER = new Date().getFullYear().toString();

export default function App() {
  useLiveSession();

  // const defaultPeriodFilterRemoved = useSessionStorage(
  //   "defaultPeriodFilterRemoved",
  //   false
  // )[0];

  // const setStartDate = useStoreActions(
  //   (actions) => actions.appliedFilters.setStartDate
  // );
  // const setEndDate = useStoreActions(
  //   (actions) => actions.appliedFilters.setEndDate
  // );

  // useComponentWillMount({
  //   action: () => {
  //     const defaultStartDate = `${DEFAULT_YEAR_FILTER}-01-01`;
  //     const defaultEndDate = `${DEFAULT_YEAR_FILTER}-12-31`;

  //     if (!defaultPeriodFilterRemoved) {
  //       setStartDate(defaultStartDate);
  //       setEndDate(defaultEndDate);
  //     } else {
  //       setStartDate("");
  //       setEndDate("");
  //     }
  //   },
  // });

  return (
    <React.Fragment>
      <Router />
      <LoginFlowBackdrop />
      <CookieSnackbar />
    </React.Fragment>
  );
}
